import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const MyApproval = () => {
    
    document.title = "Dashboard | Procurement Dashboard";
    const [rows, setRows] = useState([
        {
            productName: '',
            quantity: '',
            value: ''
        }
    ])

    const columns = [
        { field: 'Sl_No', headerName: 'Sl.No',
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        //  width: 90 
        flex: 1,
        resizable: false,
        sortable: false,
        },
        {
          field: 'Product_Name',
          headerName: 'Product Name',
          cellClassName: 'product_name_wrap',
          width: 160,
          resizable: false,
        //   width: 250,
          editable: false,
          renderCell: (params) => {
            const productName = params.value;
            return (
              <div style={{cursor:'pointer'}}>
                {productName}
              </div>
            );
          },
        },
        {
          field: 'quantity',
          headerName: 'Quantity',
          headerClassName: 'table-header-background',
          sortable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
          resizable: false,
        //   width: 160,
        },
        {
            field: 'dP_Value',
            headerName: 'DP Value',
            sortable: false,
            flex: 1,
            // width: 160,
            resizable: false,
        },
        {
            field: 'MOP',
            headerName: 'FOB',
            sortable: false,
            // width: 160,
            flex: 1,
            resizable: false,
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            sortable: false,
            cellClassName: 'product_name_wrap',
            width: 160,
            resizable: false,
            // width: 160,
            
        },
        {
            field: 'payment_term',
            headerName: 'Payment Term',
            headerClassName: 'break-header',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            resizable: false,
            // width: 160,
        },
        {
            field: 'actual_date',
            headerName: 'Actual Date',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            resizable: false,
            // width: 160,
      
        },
        {
          field: 'PO_no',
          headerName: 'PO No.',
          sortable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
          resizable: false,
          // width: 160,
      
      },
      
          {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
            width: 160,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'Waiting for response') {
                  chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                  chipColor = 'success'; // Green color for approved
                }
          
                // Render the Chip component with the outlined variant and appropriate color
                return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
              },
          },
      ];
      
      const approvalrows = [
        { id: 1, Sl_No: 1, Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-', PO_no:'PO1234', Status: 'Waiting for response' },
        { id: 2, Sl_No: 2, Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-', PO_no:'PO1234', Status: 'approved' },
      ];
    return (
        <React.Fragment>
            <Container fluid>
                <div>
                    <Box sx={{ height: 400, width: '100%', marginBottom: '10px', marginTop:'10px' }}>
                        <DataGrid
                            className="table_header_background"
                            headerClassName="custom-header-cell"
                            rows={approvalrows}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5]}
                            disableRowSelectionOnClick
                            disableColumnMenu 
                            componentsProps={{
                              cell: {
                                disableClick: true,
                              },
                            }}
                            sx={{
                              '& .MuiDataGrid-cell': {
                                '& .MuiDataGrid-cell--textOverflow': {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                },
                              },
                            }}
                        />
                    </Box>
                </div>
                </Container>
        </React.Fragment>
    );
};

export default MyApproval;
